import React, { useEffect, useRef, useState } from 'react';
import { Navbar, Nav, Image, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import NotificationBell from './Notifications/NotificationBell';
import Spinner from '../features/Spinner';

import { useSelector, useDispatch } from 'react-redux';
import { clearUser } from '../redux/auth/authSlice';
import api from '../api/axios';

  
const ROOT_URL_IMAGES = process.env.REACT_APP_ROOT_URL_IMAGES;

const CustomNavbar = () => {

  const { user, userProfile } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef();

  console.log("NavBar", {user, userProfile})

  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (err) {
      //console.error('Logout error', err);
    }
    dispatch(clearUser());
  };
  
  // Collapse navbar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expanded &&
        navbarRef.current &&
        !navbarRef.current.contains(event.target)
      ) {
        setExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [expanded]);

  const handleNavItemClick = () => {
    setExpanded(false);
  };

  const getProfileImageUrl = (userProfile) => {
    const images = userProfile?.imageUrls || [];
    const profileImage = images.find(image => image.type === 'PROFILE');
    if (profileImage) return `${ROOT_URL_IMAGES}${profileImage.imageUrl}`;
    if (images.length > 0) return `${ROOT_URL_IMAGES}${images[0].imageUrl}`;
    return '/default-avatar.png';
  };


  return (
    <Navbar
      //bg="dark"
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={() => setExpanded(prev => !prev)}
      ref={navbarRef}
      style={{backgroundColor: '#1b3c5b'}}
    >
      <Container>
        <Navbar.Brand style={styles.navbarBrandStyles} as={Link} to="/start">
        <img
          src="/logo/lumevin_dark_theme.jpg" // Update this path
          alt="Lumevin Logo"
          height="30" // Adjust height as needed
          className="d-inline-block align-top"
        />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
                {!user ? (
                <>
                    <Nav.Link as={Link} to="/home" onClick={handleNavItemClick}>Home</Nav.Link>
                    <Nav.Link as={Link} to="/login" onClick={handleNavItemClick}>Login</Nav.Link>
                    <Nav.Link as={Link} to="/register" onClick={handleNavItemClick}>Register</Nav.Link>
                </>
                ) : (
                <>
                    <Nav.Link as={Link} to="/start" onClick={handleNavItemClick}>Start</Nav.Link>
                </>
                )}
            </Nav>
            {user && (
            <Nav className="ms-auto" style={{ alignItems: 'center', gap: '1rem' }}>
              <Nav.Item>
                <NotificationBell type="likes" label="Likes" />
              </Nav.Item>
              <Nav.Item>
                <NotificationBell type="messages" label="Messages" />
              </Nav.Item>
              <Nav.Item>
                <NotificationBell type="views" label="Profile Views" />
              </Nav.Item>
              <NavDropdown
                  title={
                  <span>
                      <Image
                      src={getProfileImageUrl(userProfile)}
                      roundedCircle
                      width="30"
                      height="30"
                      className="me-2"
                      />
                      {user.displayName || 'Profile'}
                  </span>
                  }
                  id="profile-dropdown"
                  align="end">
                  <NavDropdown.Item as={Link} to={`/profile`} onClick={handleNavItemClick}>My Profile</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={ () => {handleLogout(); handleNavItemClick();}}>Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

const styles = {
  navbarBrandStyles: {
    color: '#fff' 
  }
};

export default CustomNavbar;